import { render } from "./PdfUpload.vue?vue&type=template&id=b0cf1ec2"
import script from "./PdfUpload.vue?vue&type=script&lang=js"
export * from "./PdfUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__